import { useAppSelector } from '@store/hooks';
import { useSearchRidesMutation } from '@store/rtk/rides';
import { selectHomePageModalSearch } from '@store/slices/search/homeSearchSlice';
import { useEffect, useRef, useState } from 'react';
import { useForm } from '@hooks/useDirtyForm';
import {
  defaultValues,
  FormTypes,
} from '@src/modals/HomeModals/RideSearchModal/constants';
import { useWatch } from 'react-hook-form';
import { useDebouncedValue } from '@hooks/useDebouncedValue';
import { idType } from '@src/types';
import { encrypt } from '@src/utils';
import { ContractorSearchFormValues } from '@hooks/useContractorSearch';

function buildFilters(
  values: Partial<ContractorSearchFormValues>
): Record<string, unknown> {
  const result: Record<string, unknown> = {};

  for (const [key, value] of Object.entries(values)) {
    if (value === null || value === undefined || value === '') continue;
    result[key] = value;
  }

  return result;
}

export const useRideSearch = () => {
  const SEARCH_RIDE_PAGE_SIZE = 20;
  const prevFiltersRef = useRef<string>('');

  const [searchRides, { isLoading }] = useSearchRidesMutation();

  const { searchRideData } = useAppSelector(selectHomePageModalSearch);

  const [filters, setFilters] = useState<Record<string, string>>({});

  const { control } = useForm<FormTypes>({
    defaultValues,
    mode: 'onChange',
  });

  const watchedFormValues = useWatch<FormTypes>({ control });
  const debouncedValues = useDebouncedValue<FormTypes>(
    watchedFormValues as FormTypes,
    500
  );

  useEffect(() => {
    const cleanedValues = buildFilters(
      debouncedValues as Partial<ContractorSearchFormValues>
    ) as any;

    const serialized = JSON.stringify(cleanedValues);
    if (serialized === prevFiltersRef.current) return;

    prevFiltersRef.current = serialized;
    setFilters(cleanedValues);

    searchRides({
      argument: { body: cleanedValues },
      params: { size: SEARCH_RIDE_PAGE_SIZE },
    });
  }, [debouncedValues, searchRides]);

  const handleClickEdit = (id: idType) => {
    const encodeId = encrypt({ ['ride']: id });
    window.open(`/rides/information/${encodeId}`, '_blank');
  };

  return {
    handleClickEdit,
    isLoading,
    filters,
    searchRideData,
    control,
  };
};
